<template>
  <div class="lang-cnt my-auto" :style="cssProps">
		<span v-if="labeled">{{ $t('lang') }}:</span>
    <span :class="{'active': isActive(esLocale)}" @click="$i18nHelpers.changeLang(esLocale)" :style="cssProps">ES</span>
    <span :class="{'active': isActive(EN_LOCALE)}" @click="$i18nHelpers.changeLang(EN_LOCALE)" :style="cssProps">EN</span>
    <span v-if="enablePortuguese" :class="{'active': isActive(PT_LOCALE)}" @click="$i18nHelpers.changeLang(PT_LOCALE)" :style="cssProps">PT</span>
  </div>
</template>

<script>
import { getPrimaryColour } from '@/constants/colours.js'
import { ES_LOCALE, MX_LOCALE, EN_LOCALE, PT_LOCALE } from '../../constants/locales'
export default {
  name: 'LangSelector',
  props: {
    enablePortuguese: Boolean,
    color: {
      required: false,
      type: String,
      default: getPrimaryColour()
    },
		labeled: Boolean
  },
  data () {
    return {
      lang: this.$i18n.locale,
			EN_LOCALE,
			PT_LOCALE
    }
  },
  computed: {
    esLocale () {
      return window.location.href.includes('.mx') ? MX_LOCALE : ES_LOCALE
    },
    cssProps () {
      return {'--color': this.color}
    }
  },
  methods: {
    isActive (lang) {
      return this.lang === lang
    }
  }
}
</script>

<style lang="scss" scoped>
  .lang-cnt {
    color: var(--color);
    font-weight: bold;
    /* transition: all 0.3s ease; */

    span {
      cursor: pointer;
      /* vertical-align: sub; */
      &:not(:last-child) {
        margin-right: 1rem;
      }
      

      &:hover {
        /* transition: all 0.3s ease; */
        border-top: 1px solid var(--color);
      }

      &.active {
        border-top: 2px solid var(--color);
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/base/LangSelector.vue